import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { Box, Grid, Zoom } from '@mui/material';
import { InvoiceDocumentViewer } from '../InvoiceDocument/InvoiceDocumentViewer';
import { VendorInformation } from './VendorInformation';
import { MappedInvoiceFeilds } from './MappedInvoiceFields';
import './vendormap.css';
import { VendorMapDialog } from './VendorMapDialog';
import { httpGet, httpPost } from '../../HttpRequestHandling/httpRequestHandler';
import { VendorLookup } from '../Lookups/VendorLookup';
import { toast } from 'react-toastify';
import { InvoiceDocumentEditor } from '../InvoiceDocument/InvoiceDocumentEditor';
import {
	addDaysInDate, calculateTax, formatNumber, round, stringIsNullOrEmpty, toDate, convertFromMySQLFormatCustom,
	convertToMySQLFormatCustom, formatDateByIntelligence, normalizeUiFormat, detectBillingPeriodFormat, isPeriodKey, findBillingPeriodKV, getDisplayName } from '../Common/Utilities';
import { VendorMappingDialogPrompt } from './VendorMappingPrompt';
import { ConstantsSymbols } from '../Common/Constants';
import { isBroadcastTaxGroupValid, BROADCAST_TAX_GROUP_ERROR } from '../Common/Validation';
import MultiCompanyVendorLookup from '../Lookups/MultiCompanyVendorLookup';

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Zoom in={true} ref={ref} {...props} />;
});
export function VendorMapEditorDetailDialog(props) {
	return (<Dialog open={props.isOpen} fullScreen TransitionComponent={Transition}>
		<DialogContent key={'VendorDetailDialog' + 2001} sx={{ padding: 0 }}>
			{props.isOpen && <VendorMapEditorDetails key={'VendorDetailDialog' + 2002} {...props}></VendorMapEditorDetails>}
		</DialogContent>
	</Dialog>);
}

function VendorMapEditorDetails(props) {
	// #region variables
	const style = React.useMemo(() => ({
		'cellOneStyle': {
			'textAlign': 'right',
		},
		'cellTwoStyle': {
		},
		'cellThreeStyle': {
		},
		'mainRowStyle': {
			//paddingTop: 3,
			'paddingBottom': '8px',
			'paddingLeft': '5px',
			'paddingRight': '10px'
		},
		'mainRowSpacing': 1,
		'cellOneWidth': 4,
		'cellTwoWidth': 4,
		'cellThreeWidth': 4,
		inputStyle: {}
	}), []);
	const messages = React.useMemo(() => {
		return {
			dueDateCalculated: ''/*'Caculated from invoice date using payment terms'*/
		}
	}, [])
	const regex = React.useMemo(() => {
		return {
			currency: [/^(USD|€|\$|£)?\s?-?\d{1,3}(,\d{3})*(\.\d{2})?$/, /^-\d+$/, /^\d+$/, /^-\d*\.\d+$/, /^\d*\.\d+$/],
			date: [
				// YYYY-MM-DD (ISO 8601 Format)
				/^(\d{4})-(\d{1,2})-(\d{1,2})$/,
				// MM/DD/YYYY and DD/MM/YYYY
				/^(\d{1,2})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{4})$/,
				// DD Month YYYY (Full Date with Month Name)
				/^(\d{1,2})\s([A-Za-z]+)\s(\d{4})$/,
				// DD Mon YYYY (Full Date with Month Abbreviation)
				/^(\d{1,2})\s([A-Za-z]{3})\s(\d{4})$/,
				// YYYYMMDD (Compact Format)
				/^(\d{4})(\d{1,2})(\d{1,2})$/,
				// Day, DD Month YYYY (Full Date with Day of the Week)
				/^[A-Za-z]+,\s(\d{2})\s([A-Za-z]+)\s(\d{4})$/,
				// Month YYYY (Month/Year Only)
				/^[A-Za-z]+\s(\d{4})$/,
				// YYYY-MM-DDTHH:mm:ssZ (ISO 8601 Extended)
				/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})Z$/,
				// DD.MM.YYYY (Numeric with Dots)
				/^(\d{1,2})\.(\d{1,2})\.(\d{4})$/,

				// DD-MM-YYYY (Numeric with Dashes)
				/^(\d{1,2})-(\d{1,2})-(\d{4})$/,

				// YYYY-MM-DDTHH:mm:ss
				/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})$/,

				// YYYY/MM/DD
				/^(\d{4})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{1,2})$/,

				// MM-DD-YYYY
				/^(\d{1,2})-(\d{1,2})-(\d{4})$/,

				// YYYY.MM.DD
				/^(\d{4})\.(\d{1,2})\.(\d{1,2})$/,

				// Month DD, YYYY
				/^[A-Za-z]+\s(\d{1,2}),\s(\d{4})$/,

				// DD Month, YYYY
				/^(\d{1,2})\s([A-Za-z]+),\s(\d{4})$/,

				// DD/MM/YY (Two-digit year)
				/^(\d{1,2})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{2})$/,

				// Additional formats for MMM and MMMM with separators
				/^([A-Za-z]{3,9})[\/\-\.\s](\d{1,2})[\/\-\.\s](\d{4})$/,
				/^(\d{1,2})[\/\-\.\s]([A-Za-z]{3,9})[\/\-\.\s](\d{4})$/,

				// ✅ New: "MMM DD YYYY" (e.g., "Oct 1 2001", "Nov 15 1995")
				/^([A-Za-z]{3})\s(\d{1,2})\s(\d{4})$/,

				// ✅ New: Month abbreviation with period (Dec. 01, 2023)
				/^([A-Za-z]{3})\.\s(\d{1,2}),\s(\d{4})$/,

				// ✅ New: Day first with period in month (01 Dec. 2023)
				/^(\d{1,2})\s([A-Za-z]{3})\.,\s(\d{4})$/
			],
			number : [
				/^\d+$/,          // Matches one or more digits
				/^\d{1,}$/,       // Matches one or more digits (alternative)
				/^[0-9]+$/,       // Matches one or more digits (alternative using range)
				/^[0-9]{1,}$/     // Matches one or more digits (alternative with range repetition)
			]
		}
	}, []);
	const formats = React.useMemo(() => {
		return {
			date: [
				"YYYY-MM-DD",                                  // ISO 8601 Format
				"MM/DD/YYYY",                                  // US Format
				"DD/MM/YYYY",                                  // European Format
				"DD Month YYYY",                               // Full Date with Month Name
				"DD Mon YYYY",                                 // Full Date with Month Abbreviation
				"YYYYMMDD",                                    // Compact Format
				"Day, DD Month YYYY",                          // Full Date with Day of the Week
				"Month YYYY",                                  // Month/Year Only
				"YYYY-MM-DDTHH:mm:ssZ",                        // Date and Time (ISO 8601 Extended)
				"DD.MM.YYYY",                                  // Numeric with Dots
				"DD-MM-YYYY",                                 // Numeric with Dashes
				'YYYY-MM-DDTHH:mm:ss'
			]
		}
	})
	const symbols = React.useMemo(() => {
		return {
			paymentTerms: ['PaymentTerms', 'Payment Terms', 'paymenttersm', 'payment terms', 'payment terms:', 'paymentterms:'],
			subtotalfields: ['SubTotal', 'sub total:', 'subtotal', 'Sub Total:'],
			taxtotalfields: ['TotalTax', 'totaltax', 'total tax:', 'Total Tax:'],
			invoiceTotalFields: ['InvoiceTotal', 'invoice total:', 'Invoice Total:', 'invoicetotal']
		}
	});

	// #endregion
	// #region states
	const [documentVendorMapping, setDocumentVendorMapping] = React.useState(null);
	const [vendorDialogOpen, setVendorDialogOpen] = React.useState(false);
	const [fieldData, setFieldData] = React.useState('');
	const [vendorIdentifier, setVendorIdentifier] = React.useState('')
	const [editorType, setEditorType] = React.useState('summary');
	const [hasTax, setHasTax] = React.useState(false);
	const [hasInvoiceTax, setHasInvoiceTax] = React.useState(false);
	const [taxSettings, setTaxSettings] = React.useState(null);
	const [taxCode, setTaxCode] = React.useState('');
	const [taxes, setTaxes] = React.useState([]);
	const [backendTaxes, setbackendTaxes] = React.useState([]);
	const [paymentTerms, setPaymentTerms] = React.useState(null);
	const [taxAmount, setTaxAmount] = React.useState({ calculatedAmount: '', isValid: true });
	const [invoiceTaxAmount, setInvoiceTaxAmount] = React.useState({ calculatedAmount: '', isValid: true });
	const [markAsCompleted, setMarkAsCompleted] = React.useState(false);
	const [processInvoice, setProcessInvoice] = React.useState(() =>
		!['Copy', 'Revise', 'View'].includes(props.info?.mode)
	);
	const manualFields = ['mediaType', 'callLetter', 'band'];
	const [openMultiCompanyDialog, setOpenMultiCompanyDialog] = React.useState(false);
	const [selectedCompanyList, setSelectedCompanyList] = React.useState([]);
	const [companyName, setcompanyName] = React.useState([]);
	const [resultDialogOpen, setResultDialogOpen] = React.useState(false);
	const [resultMessages, setResultMessages] = React.useState({ success: [], failure: [] });
	const [mappedFields, setMappedFields] = React.useState({
		vendorIdentifier: { value: vendorIdentifier, requestField: '', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '', parentSection: '', section: 'vendor' },
		currencyCode: { value: '', requestField: '', mappedField: '', causeField: '', affectField: '', type: '', defaultMapping: 'CurrencyCode', parentSection: '', section: 'vendor' },
		vendor: { value: '', requestField: '', type: '', name: 'Vendor', required: true, mappedField: '', causeField: '', affectField: '', defaultMapping: 'VendorAddressRecepient', parentSection: '', section: 'vendor' },
		invoiceNumber: { value: '', requestField: 'invoiceId', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'InvoiceId', parentSection: '', section: 'mapped' },
		invoiceDate: { value: '', requestField: 'invoiceDate', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'InvoiceDate', parentSection: '', section: 'mapped' },
		dueDate: { value: '', title: '', requestField: 'dueDate', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'DueDate', parentSection: '', section: 'mapped' },
		serviceTermStartDate: { value: '', requestField: 'serviceStartDate', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'ServiceStartDate', parentSection: '', section: 'mapped' },
		serviceTermEndDate: { value: '', requestField: 'serviceEndDate', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'ServiceEndDate', parentSection: '', section: 'mapped' },
		paymentTermCode: { value: '', requestField: 'paymentTerms', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'PaymentTerm', parentSection: '', section: 'mapped' },
		invoiceCurrency: { value: '', requestField: 'invoiceCurrencyCode', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '', parentSection: '', section: 'mapped' },
		invoiceAmount: {
			value: '', requestField: 'invoiceAmount', type: '', mappedField: '', causeField: ['TotalTax', 'totaltax', 'total tax:', 'Total Tax:'],
			affectField: ['SubTotal', 'sub total:', 'subtotal', 'Sub Total:'], defaultMapping: 'InvoiceTotal', parentSection: '', section: 'mapped'
		},
		totalSpots: { value: '', requestField: 'totalSpot', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '$function', parentSection: '', section: 'mapped' },
		//invoiceHasTax: { value: false, mappedField: '', defaultMapping: '', section: 'mapped' },
		//tax: { value: '', mappedField: '', defaultMapping: '', section: 'mapped' },
		ioNumber: { value: '', requestField: 'poCode', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'PurchaseOrder', parentSection: '', section: 'mapped|details' },
		level2Key: { value: '', requestField: 'level2Key', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '$function', parentSection: '', section: 'details' },
		level3Key: { value: '', requestField: 'level3Key', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '$function', parentSection: '', section: 'details' },
		rTypeName: { value: '', requestField: 'expenseType', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '$function', parentSection: '', section: 'details' },
		ioDescription: { value: '', requestField: 'description', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'Description', parentSection: '', section: 'details' },
		taxCode: { value: '', requestField: 'tax', mappedField: '', causeField: '', affectField: '', type: '', defaultMapping: '', parentSection: '', section: 'details' },
		ioInvoiceAmount: { value: '', requestField: 'amount', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'Amount', parentSection: '', section: 'details' },
		//matchToDateNet: { value: '', requestField: 'amount', type: '', mappedField: '', defaultMapping: 'Amount_1', parentSection: '', section: 'details' },
		quantity: { value: '', requestField: 'quantity', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'Quantity', parentSection: '', section: 'details' },
		invoiceTax: { value: '', requestField: 'invoiceTax', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '', parentSection: '', section: 'mapped' },
		additionalVendorIdentifier: {value: '', requestField: '', mappedField: '', type: 'string', defaultMapping: '', parentSection: '', section: 'mapped'},
		broadcastClient: { value: '', requestField: 'broadcastClient', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '', parentSection: '', section: 'mapped' },
		broadcastProduct: { value: '', requestField: 'broadcastProduct', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: '', parentSection: '', section: 'mapped' },
		bandKeyValue: { value: '', requestField: 'bandKeyValue', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'Band', parentSection: '', section: 'mapped' },
		callLetterKeyValue: { value: '', requestField: 'callLetterKeyValue', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'CallLetter', parentSection: '', section: 'mapped' },
		contractNumber: { value: '', requestField: 'contractNumber', type: '', mappedField: '', causeField: '', affectField: '', defaultMapping: 'ContractNumber', parentSection: '', section: 'mapped' }
	});
	const mappingMethods = React.useMemo(() => {
		return {
			totalSpots: (data) => {
				let filterDataFields = data?.filter((e) => String(e?.set || '').toLowerCase() !== 'lineitems' && e.Key?.toLowerCase().indexOf('spot') != -1);
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			level2Key: (data) => {

				let keyList = ['project','campaign', 'job', 'level2', 'level2key']
				let filterDataFields = data?.filter(e => keyList.some(key => (e.set !='Records' && e.Key?.replaceAll(' ', '').toLowerCase() || '').indexOf(key) != -1));
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			level3Key: (data) => {
				let keyList = ['activity', 'level3', 'level3key']
				let filterDataFields = data?.filter(e => keyList.some(key => (e.set != 'Records' && e.Key?.replaceAll(' ', '').toLowerCase() || '').indexOf(key) != -1));
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			rTypeName: (data) => {
				let keyList = ['restype', 'rtypename', 'costcode', 'costtype','expense']
				let filterDataFields = data?.filter(e => keyList.some(key => (e.set != 'Records' && e.Key?.replaceAll(' ', '').toLowerCase() || '').indexOf(key) != -1));
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			broadcastClient: (data) => {
				let keyList = ['customername', 'customer', 'clientname', 'client', 'advertisername', 'advertiser', 'agencyname', 'agency', 'accountname', 'account', 'billtoname', 'billto'];
				let filterDataFields = data?.filter(e => {
					const sourceKey = String(e.Key || '').toLowerCase().replace(/[^a-z0-9]/g, '');
					return keyList.some(key => sourceKey.indexOf(String(key).toLowerCase().replace(/[^a-z0-9]/g, '')) !== -1);
				});
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			broadcastProduct: (data) => {
				let keyList = ['productname', 'product', 'productcode', 'itemname', 'item', 'brandname', 'brand'];
				let filterDataFields = data?.filter(e => {
					const sourceKey = String(e.Key || '').toLowerCase().replace(/[^a-z0-9]/g, '');
					return keyList.some(key => sourceKey.indexOf(String(key).toLowerCase().replace(/[^a-z0-9]/g, '')) !== -1);
				});
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			contractNumber: (data) => {
				let keyList = ['contractnumber', 'contractno', 'contractid', 'contract', 'agreementnumber', ];
				let filterDataFields = data?.filter(e => {
					const sourceKey = String(e.Key || '').toLowerCase().replace(/[^a-z0-9]/g, '');
					return keyList.some(key => sourceKey.indexOf(String(key).toLowerCase().replace(/[^a-z0-9]/g, '')) !== -1);
				});
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			},
			mediaType: (data) => {
				let keyList = ['mediatype', 'mediatypecode', 'mediatypename', 'media', 'mediacategory', 'channel', 'vehicle'];
				let filterDataFields = data?.filter(e => {
					const sourceKey = String(e.Key || '').toLowerCase().replace(/[^a-z0-9]/g, '');
					return keyList.some(key => sourceKey.indexOf(String(key).toLowerCase().replace(/[^a-z0-9]/g, '')) !== -1);
				});
				if (filterDataFields.length > 0) {
					return filterDataFields[0];
				}
				return '';
			}
		};
	},[])
	const [isVendorDialogOpen, setIsVendorDialogOpen] = React.useState(false);
	const [vendor, setVendor] = React.useState(null);
	const [invoiceCurrency, setInvoiceCurrency] = React.useState(null);
	const [invoiceDocumentEditorDialogOpen, setInvoiceDocumentEditorDialogOpen] = React.useState(false);
	const [isFirstMap, setIsFirstMap] = React.useState(false);
	const [loadComplete, setLoadComplete] = React.useState(false);
	const [vendorloadComplete, setVendorLoadComplete] = React.useState(false);
	const [isDirty, setIsDirty] = React.useState(true);
	const [maxWeightedLine, setMaxWeightedLine] = React.useState(0);
	const [advanceEdit, setAdvanceEdit] = React.useState(false);
	const [previewInvoiceDocument, setPreviewInvoiceDocument] = React.useState(null);
	const [readOnly, setReadOnly] = React.useState(/*props.info.mode === 'View'*/ false);
	const [dateFormats, setDateFormats] = React.useState({
		invoiceDateFieldFormat: '',
		dueDateFieldFormat: '',
		serviceTermStartDateFieldFormat: '',
		serviceTermEndDateFieldFormat: ''
	});
	const [markAsFinalPrompt, setMarkAsFinalPrompt] = React.useState({
		isOpen: false,
		message: '',
		title: ''
	});
	const [invoiceUserStatuses, setInvoiceUserStatuses] = React.useState([]);
	const [invoiceUserStatusId, setInvoiceUserStatusId] = React.useState('');
	const [bandValidation, setBandValidation] = React.useState({ isValid: true, message: '' });
	const bandValidationRef = React.useRef({ isValid: true, message: '' });
	const callLetterValidatorRef = React.useRef(async () => true);
	const skipCallLetterBlurRef = React.useRef(false);
	const invoiceUserStatusIdRef = React.useRef('');
	const userStatusDisplayName = React.useMemo(() => getDisplayName('User Status'), []);
	// #endregion
	// #region Memos
	const isChangingNotAllowed = React.useMemo(() => (props.info.mode === 'View'), []);
	const canProcessInvoice = !['Copy', 'Revise', 'View'].includes(props.info?.mode);
	const shouldAlwaysShowVendorMapDialog = React.useMemo(() => props.forceVendorMapPrompt === true, [props.forceVendorMapPrompt]);

	// #endregion
	// #region side effects
	React.useEffect(() => {
		httpGet('api/setup/getInvoiceUserStatus')
			.then((response) => {
				setInvoiceUserStatuses(response?.data?.record || []);
			})
			.catch(() => {
				setInvoiceUserStatuses([]);
			});
	}, []);

	React.useEffect(() => {

		httpGet('api/InvoiceDocument/documentvendormapping/' + props.info.invoiceDocument.invoiceDocumentId + '/' + (props.info.invoiceDocument.revisionId || ''))
			.then((response) => {
				let data = response?.data;
				var taxes = [];
				setbackendTaxes(data?.taxes || []);
				if (data?.taxes) {
					data?.taxes?.forEach(t => {
						if (taxes.find(tt => tt.taxCode === t.taxCode) == null) {
							taxes.push(t);
						}
					});
				}
				setTaxes(taxes || []);
				setPaymentTerms(paymentTermsToFlatObject(data?.paymentTerms));
				if (data && data.fieldData && data.vendorIdentifier) {
					let jsonData = modifyJsonData(JSON.parse(data.fieldData), { CurrencyCode: data?.documentVendorMapping?.currencyCode || "" });
					data.fieldData = jsonData;
					//let jsonToObjectFieldData =JSON.parse(jsonData);
					let jsonToObjectFieldData = JSON.parse(data.fieldData);
					setFieldData(transformToIdentity(jsonToObjectFieldData));
					setVendorIdentifier(data.vendorIdentifier);
					const isFirstTimeVendorMapping = data?.documentVendorMapping?.detailflag == null;
					const shouldOpenVendorMapDialog = shouldAlwaysShowVendorMapDialog || isFirstTimeVendorMapping;

					setVendorDialogOpen(shouldOpenVendorMapDialog);

					if (isFirstTimeVendorMapping) {
						setMarkAsCompleted(true);
					} else {
						setMarkAsCompleted(data?.documentVendorMapping?.markAsCompleted);
					}
					setEditorType(data?.documentVendorMapping?.detailflag ? 'detail' : 'summary');
					const localTax = data?.documentVendorMapping?.localTax || data?.documentVendorMapping?.invoiceLocalTax;
					setHasTax(((data?.documentVendorMapping?.taxCode /*&& data?.documentVendorMapping?.taxSetting === 1*/)
						|| (data?.documentVendorMapping?.invoiceTax /*&& data?.documentVendorMapping?.taxSetting === 2*/)
						|| localTax) ? true : false);
					setHasInvoiceTax((data?.documentVendorMapping?.invoiceTax || localTax) ? true : false);
					setTaxSettings(data?.documentVendorMapping?.taxSetting);
					setTaxCode(data?.documentVendorMapping?.taxCode || '');
					setVendor(data?.vendor);
					setInvoiceCurrency(data?.documentVendorMapping?.currencyCode);
					const nextInvoiceUserStatusId = data?.documentVendorMapping?.invoiceUserStatusId || '';
					setInvoiceUserStatusId(nextInvoiceUserStatusId);
					invoiceUserStatusIdRef.current = nextInvoiceUserStatusId;
					setDocumentVendorMapping(data.documentVendorMapping);
					//getMappedKeysFromRequest(data);
					mapToVendorFields(data);
					setDateFormats({
						invoiceDateFieldFormat: convertFromMySQLFormatCustom(data?.documentVendorMapping?.invoiceDateFieldFormat) || "",
						dueDateFieldFormat: convertFromMySQLFormatCustom(data?.documentVendorMapping?.dueDateFieldFormat) || "",
						serviceTermStartDateFieldFormat: convertFromMySQLFormatCustom(data?.documentVendorMapping?.serviceStartDateFieldFormat) || "",
						serviceTermEndDateFieldFormat: convertFromMySQLFormatCustom(data?.documentVendorMapping?.serviceEndDateFieldFormat) || ""
					});
				}
				else {
					toast.error(<div>Vendor mapping fetch failed</div>);
					props.info.inProgress(false);
					props.onClose();
				}
			})
			.catch((xhr) => {
				toast.error(<div>Vendor mapping fetch failed</div>);
				props.info.inProgress(false);
				props.onClose();
			})
	}, []);
	// for sequential execution of mapping values.
	React.useEffect(() => {
		if (isFirstMap) {
			getMappedKeysFromRequest({
				fieldData: fieldData,
				documentVendorMapping: documentVendorMapping,
				vendorIdentifier: vendorIdentifier,
				vendor: vendor
			});
			setIsFirstMap(false);
		}
	}, [isFirstMap])
	React.useEffect(() => {
		if (loadComplete && vendorloadComplete) {
			let _taxAmount = structuredClone(taxAmount);
			let subtotalfields = symbols.subtotalfields;
			let taxtotalfields = symbols.taxtotalfields;
			let invoiceTotalFields = symbols.invoiceTotalFields;
			let sub = null;
			let tax = null;
			let net = null;
			for (let item of subtotalfields) {
				sub = getObjectfromFieldDataRecord(item);
				if (sub) break;
			}
			for (let item of taxtotalfields) {
				tax = getObjectfromFieldDataRecord(item);
				if (tax) break;
			}
			for (let item of invoiceTotalFields) {
				net = getObjectfromFieldDataRecord(item);
				if (net) break;
			}

			const rawInvoiceAmount = mappedFields.invoiceAmount.value;
			const sanitizedInvoiceAmount = (typeof rawInvoiceAmount === 'number')
				? String(rawInvoiceAmount)
				: String(rawInvoiceAmount || '').replace(/[a-zA-Z€\$£\s]/g, '').replace(/,/g, '');

			if (taxCode && mappedFields.invoiceAmount.mappedField &&
				(rawInvoiceAmount || (typeof rawInvoiceAmount === 'number')) &&
				(!isNaN(sanitizedInvoiceAmount) || regex['currency'].some(e => e.test(sanitizedInvoiceAmount)))) {

				let selectedTaxes = backendTaxes.filter(e => e.taxCode === taxCode);
				let totalCalculatedTax = 0;

				let fetchedValue = (typeof rawInvoiceAmount === 'number')
					? rawInvoiceAmount
					: parseFloat(sanitizedInvoiceAmount);

				selectedTaxes.forEach(_selectedTax => {
					let calculatedTax = 0;

					if (_selectedTax.taxIncludedFlag == 1) {
						if (_selectedTax.prcFlag === 1) {
							calculatedTax = parseFloat(fetchedValue) * (_selectedTax.otherTaxAmt / 100) /
								(1 + (_selectedTax.otherTaxAmt / 100));
						} else {
							calculatedTax = _selectedTax.otherTaxAmt;
						}
					} else {
						if (_selectedTax.prcFlag === 1) {
							calculatedTax = parseFloat(fetchedValue) * (_selectedTax.otherTaxAmt / 100);
						} else {
							calculatedTax = _selectedTax.otherTaxAmt;
						}
					}

					totalCalculatedTax += calculatedTax;
				});

				totalCalculatedTax = round(totalCalculatedTax, 2);

				let isValidTax = (!tax || round(parseFloat(tax.Value), 2) === totalCalculatedTax);
				_taxAmount = {
					calculatedAmount: formatNumber(totalCalculatedTax),
					isValid: isValidTax
				};
			} else {
				_taxAmount = { calculatedAmount: '', isValid: true };
			}
			let _mappedFields = structuredClone(mappedFields);
			if (!hasTax) {
				_taxAmount = { calculatedAmount: '', isValid: true };
				if (net && subtotalfields.some(e => e === mappedFields.invoiceAmount.mappedField)) {
					_mappedFields.invoiceAmount = { ..._mappedFields.invoiceAmount, value: net?.Value, mappedField: net?.Key, type: net?.ValueType }
					setMappedFields(_mappedFields);
				}
			} else {
				if (sub && invoiceTotalFields.some(e => e === mappedFields.invoiceAmount.mappedField)) {
					_mappedFields.invoiceAmount = { ..._mappedFields.invoiceAmount, value: sub?.Value, mappedField: sub?.Key, type: sub?.ValueType }
					setMappedFields(_mappedFields);
				}
			}

			setTaxAmount(_taxAmount);
		}
	}, [taxCode, vendorloadComplete, hasTax, mappedFields.invoiceAmount.mappedField]);

	// set caluated fields on load
	React.useEffect(() => {
		const _mappedFields = structuredClone(mappedFields);
		if (loadComplete) {
			if (vendor) {
				if (!mappedFields.currencyCode.value) {
					_mappedFields.currencyCode.value = vendor.currencyCode;
				}
				if (!mappedFields.paymentTermCode.value && !mappedFields.paymentTermCode.mappedField) {
					if (mappedFields.paymentTermCode.value !== vendor.termsCode) {
						_mappedFields.paymentTermCode.value = vendor.termsCode;
					}
				}
				else if ((mappedFields.paymentTermCode.value &&
					mappedFields.paymentTermCode.mappedField &&
					symbols.paymentTerms.some((e) => e === mappedFields.paymentTermCode.value) &&
					!paymentTerms[mappedFields?.paymentTermCode?.value?.toLowerCase()])
				)
				{
					_mappedFields.paymentTermCode.mappedField = '';
					_mappedFields.paymentTermCode.type = '';
					_mappedFields.paymentTermCode.value = vendor.termsCode;
				}
			}
			if (mappedFields.invoiceDate.value && !mappedFields.dueDate.value) {
				if (!mappedFields.dueDate.mappedField) {
					let termcode = paymentTerms[mappedFields?.paymentTermCode?.value?.toLowerCase()] || paymentTerms[vendor?.termsCode?.toLowerCase()] || '';
					let date = null;
					try { date = new Date(mappedFields.invoiceDate.value); } catch (ex) { date = null; }
					if (date) {
						if (termcode) {
							let cdate = addDaysInDate(date, termcode.daysDue);
							if (cdate != 'Invalid Date') {
								_mappedFields.dueDate.value = toDate(addDaysInDate(date, termcode.daysDue));
								_mappedFields.dueDate.title = messages.dueDateCalculated;
							}
							else {
								_mappedFields.dueDate.value = '';
							}
						}
					}
				}
			}

			setMappedFields(_mappedFields);
			setVendorLoadComplete(true);
		}
	}, [vendor, loadComplete])
	// set calculated fields on load end

	// set due date on change
	React.useEffect(() => {
		const _mappedFields = structuredClone(mappedFields);
		if (loadComplete && vendorloadComplete) {
			let termcode = paymentTerms[mappedFields?.paymentTermCode?.value?.toLowerCase()] || paymentTerms[vendor?.termsCode?.toLowerCase()] || '';
			let date = null;
			try { date = new Date(mappedFields.invoiceDate.value); } catch (ex) { date = null; }

			if (vendor && termcode) {
				let fromInvoice = paymentTerms[mappedFields?.paymentTermCode?.value?.toLowerCase()];
				if (!fromInvoice && !mappedFields?.paymentTermCode?.mappedField) {
					_mappedFields.paymentTermCode.value = vendor.termsCode;
				}
				else if (!fromInvoice && mappedFields?.paymentTermCode?.mappedField) {
					if (symbols.paymentTerms.some((e) => e === mappedFields?.paymentTermCode?.mappedField)) {
						_mappedFields.paymentTermCode.mappedField = '';
						_mappedFields.paymentTermCode.type = '';
						_mappedFields.paymentTermCode.value = vendor.termsCode;
					}
				}
			}


			if (mappedFields.invoiceDate.value && !mappedFields.dueDate.value) {
				if (!mappedFields.dueDate.mappedField) {
					if (date) {
						if (termcode) {
							let cdate = addDaysInDate(date, termcode.daysDue);
							if (cdate != 'Invalid Date') {
								_mappedFields.dueDate.value = toDate(addDaysInDate(date, termcode.daysDue));
								_mappedFields.dueDate.title = messages.dueDateCalculated;
							}
							else {
								_mappedFields.dueDate.value = '';
							}
						}
					}
				}
			} else if (!mappedFields.invoiceDate.value && !mappedFields.dueDate.mappedField) {
				_mappedFields.dueDate.value = '';
			}
			else if (mappedFields.invoiceDate.value && !mappedFields.dueDate.mappedField && mappedFields.dueDate.value) {
				if (date) {
					let cdate = addDaysInDate(date, termcode.daysDue);
					if (cdate != 'Invalid Date') {
						let current = toDate(cdate);
						let prev = mappedFields.dueDate.value;
						if (current !== prev) {
							_mappedFields.dueDate.value = current;
							_mappedFields.dueDate.title = messages.dueDateCalculated;
						}
					}
					else {
						_mappedFields.dueDate.value = '';
					}
				}

			}

			setMappedFields(_mappedFields);
		}
	}, [mappedFields.dueDate.mappedField, mappedFields.invoiceDate.mappedField, mappedFields.paymentTermCode.mappedField])


		React.useEffect(() => {
				var totalTaxAmount = 0;
			var _keyTaxes = mappedFields?.invoiceTax?.value?.split(ConstantsSymbols.TAXKEYS_DELIM).filter(e=>e);
			let isValid = false;
			if (_keyTaxes) {
				isValid = _keyTaxes.length <= 0;
				for (let key of _keyTaxes) {
					var obj = getObjectfromFieldDataKeyValues(key, fieldData);
					if (obj) {
						totalTaxAmount += parseFloat(String(obj.Value ?? '0').replace(/[^0-9\.\-]/g, ''));
					}
				}
				totalTaxAmount = totalTaxAmount?.toFixed(2) || 0;
				if (!isValid) {
					let totalAmount = mappedFields['invoiceAmount'].value;
					if (totalAmount) {
						totalAmount = parseFloat(String(totalAmount).replace(/[a-zA-Z€\$£\s]/g, '').replace(/,/g, ''));
						for (let taxItem of taxes) {
							var filteredTaxes = backendTaxes.filter(e => e.taxCode === taxItem.taxCode);
							var taxAmount = filteredTaxes.reduce((a, b) => { return a + calculateTax(b, totalAmount) }, 0);
							if (totalTaxAmount === taxAmount) {
							 isValid = true;
							}
						}
					}
				}
			}
		
			setInvoiceTaxAmount({ calculatedAmount: totalTaxAmount, isValid: isValid });
		}, [mappedFields.invoiceTax, mappedFields.invoiceAmount, fieldData, backendTaxes,taxes])
		// set due date on change

		// #endregion
		// #region unused items still maybe needed
		const getMediaDetails = React.useCallback(() => {
			return fieldData['Lineitems']?.map((item, index) => {
				let dmf = mappedFields.ioDescription.mappedField;
				let iom = mappedFields.ioNumber;
				let ioa = mappedFields.ioInvoiceAmount.mappedField;
				return {
					poAmount: 0,
					deliveryAmount: null,
					taxCode: taxCode,
					taxAmount: 0,
					companyCode: props.info?.invoiceDocument?.companyCode,
					invoiceDocumentId: props.info?.invoiceDocument?.invoiceDocumentId,
					vendorCode: vendor?.vendorCode,
					seqId: index + 1,
					siteId: vendor?.siteId,
					ioNumber: (editorType === 'detail') ? (iom.mappedField ? item.line.filter(e => e.Key === iom.mappedField)[0]?.Value : '') : iom.value,
					vendorName: vendor?.shortName,
					ioDescription: (dmf ? item.line.filter(e => e.Key === dmf)[0]?.Value : ''),
					ioInvoiceAmount: (ioa ? item.line.filter(e => e.Key === ioa)[0]?.Value : ''),
					invoiceDocumentDetailTaxes: taxes
				};
			})
		}, [fieldData, mappedFields, taxes, taxCode, vendor, hasTax, editorType]);

		React.useEffect(() => {
			if (props.info?.invoiceDocument?.companyCode != undefined)
				fetchCompanyList();
		}, [props.info?.invoiceDocument?.companyCode]);
		const getProductionDetails = React.useCallback(() => {
			return fieldData['Lineitems']?.map((item, index) => {
				let dmf = mappedFields.ioDescription.mappedField;
				let ioa = mappedFields.ioInvoiceAmount.mappedField;
				let qmf = mappedFields.quantity.mappedField
				let emf = mappedFields.rTypeName.mappedField;
				let l2mf = mappedFields.level2Key.mappedField;
				let l3mf = mappedFields.level3Key.mappedField;
				let iom = mappedFields.ioNumber;
				let obj = {
					poCode: (iom.mappedField ? item.line.filter(e => e.Key === iom.mappedField)[0]?.Value : ''),
					netCost: null,
					matchToDateNet: 0,
					remainingAmount: 0,
					rTypeName: (emf ? item.line.filter(e => e.Key === emf)[0]?.Value : ''),
					level2Description: null,
					poRequiredFlag: null,
					tolerancePOFlag: null,
					tolerancePOAmount: 0,
					isIONumberValid: "Y",
					isLevel2KeyValid: "Y",
					isLevel3KeyValid: "Y",
					isCostCodesValid: "Y",
					taxCode: taxCode,
					taxAmount: 0,
					companyCode: props.info?.invoiceDocument?.companyCode,
					invoiceDocumentId: props.info?.invoiceDocument?.invoiceDocumentId,
					vendorCode: vendor?.vendorCode,
					seqId: index + 1,
					siteId: vendor?.siteId,
					vendorName: vendor?.shortName,
					level2Key: (l2mf ? item.line.filter(e => e.Key === l2mf)[0]?.Value : ''),
					level3Key: (l3mf ? item.line.filter(e => e.Key === l3mf)[0]?.Value : ''),
					costType: (emf ? item.line.filter(e => e.Key === emf)[0]?.Value : ''),
					resType: null,
					ioDescription: (dmf ? item.line.filter(e => e.Key === dmf)[0]?.Value : ''),
					quantity: (qmf ? item.line.filter(e => e.Key === qmf)[0]?.Value : ''),
					ioInvoiceAmount: (ioa ? item.line.filter(e => e.Key === ioa)[0]?.Value : ''),
					invoiceDocumentDetailTaxes: taxes
				};
				return obj;
			})
		}, [fieldData, mappedFields, taxes, taxCode, vendor, hasTax, editorType]);
		const mappedFieldstoInvoiceModel = React.useMemo(() => {
			let obj = {};
			for (let key in mappedFields) {
				obj[key] = mappedFields[key].value
			}
			if (props.info?.invoiceDocument) {
				obj = {
					...obj, ...props.info.invoiceDocument
					, taxes: taxes, vendor: vendor
					, poCode: mappedFields.ioNumber.value
					, serviceTermEndDateString: mappedFields.serviceTermEndDate.value
					, serviceTermStartDateString: mappedFields.serviceTermStartDate.value
					, dueDateString: mappedFields.dueDate.value
					, invoiceDateString: mappedFields.invoiceDate.value
					, glDateString: mappedFields.invoiceDate.value
					, invoiceDocumentEditorDetails: (props.info.modelDefId === 1) ? getMediaDetails() : getProductionDetails()
				};
			}
			return obj;
		}, [fieldData, mappedFields, taxes, taxCode, vendor, hasTax, editorType, getMediaDetails, getProductionDetails]);
		// #endregion
		// #region event_handlers
	const validateFields = React.useCallback(() => {
		let errorList = [];
		for (let key in mappedFields) {
			if (mappedFields[key].required && !mappedFields[key].value) {
				errorList.push(`${mappedFields[key].name} is required`)
			}
		}

		if (!bandValidationRef.current.isValid) {
			errorList.push(bandValidationRef.current.message || 'Incorrect band. This band does not belong to the selected media type.');
		}

		if (props.info?.modelDefId === 3 && taxCode && !isBroadcastTaxGroupValid(taxCode, backendTaxes)) {
			errorList.push(BROADCAST_TAX_GROUP_ERROR);
		}

		return errorList;
	}, [mappedFields, props.info?.modelDefId, taxCode, backendTaxes])

	const registerCallLetterValidator = React.useCallback((validatorFn) => {
		callLetterValidatorRef.current = typeof validatorFn === 'function' ? validatorFn : async () => true;
	}, []);

	const validateCallLetterBeforeSave = React.useCallback(async () => {
		if (props.info?.modelDefId !== 3) {
			return true;
		}

		const validator = callLetterValidatorRef.current;
		if (typeof validator !== 'function') {
			return true;
		}

		return await validator({ showErrorToast: true, showInlineLoader: true });
	}, [props.info?.modelDefId]);

	//const save_clickHandler = React.useCallback(() => {
	//	if (markAsCompleted) {
	//		let validation = validateFields();
	//		if (validation.length > 0) {
	//			toast.error(<div>{validation.map(e => <div>{e}</div>)}</div>, { allowHtml: true });
	//			return;
	//		}
	//	}
	//	saveHttp_call()?.then((response) => {
	//		props.onClose();
	//		toast.success(<div>Vendor mapping updated successfully</div>);
	//		props.info.inProgress(false);
	//		setOpenMultiCompanyDialog(true);
	//	})
	//		.catch((xhr) => {
	//			toast.error(<div>{'Vendor mapping update failed ' + (xhr || '')}</div>);
	//			props.info.inProgress(false);
	//		})
	//}, [mappedFields, taxCode, editorType, vendor, markAsCompleted, dateFormats]);
	const save_clickHandler = React.useCallback(async () => {
		if (markAsCompleted) {
			let validation = validateFields();
			if (validation.length > 0) {
				toast.error(<div>{validation.map(e => <div key={e}>{e}</div>)}</div>, { allowHtml: true });
				return;
			}
			let mappedObject = getUserMappedValues();
			if (mappedObject.additionalVendorIdentifier === "InvoiceContains") {

				const typedValue = mappedObject.additionalVendorIdentifierValue;

				if (!typedValue || String(typedValue).trim() === "") {
					toast.error(<div>Please enter a value for Additional Vendor Identifier.</div>);
					props.info.inProgress(false);
					return;
				}

				if (!validateInvoiceContainsText(typedValue)) {
					toast.error(<div>Entered Additional Vendor Identifier text does not exist on the invoice.</div>);
					props.info.inProgress(false);
					return;
				}
			}
			const isRevisionMode = props.info?.mode === 'Copy' && props.info?.invoiceDocument?.type === 'Vendor Map';
			if (!isRevisionMode && selectedCompanyList.length > 0) {
				setOpenMultiCompanyDialog(true);
			}
			else {
				saveHttp_call()
					.then((response) => {
						props.onClose(
							{
								reopenInvoice: processInvoice === true,
								invoiceDocumentId: props.info?.invoiceDocument?.invoiceDocumentId
							},
							true
						);
						toast.success(<div>Vendor mapping updated successfully</div>);
						props.info.inProgress(false);
					})
					.catch((xhr) => {
						const backendMsg =
							xhr?.response?.data?.errorMessage ||
							xhr?.response?.data?.message ||
							xhr?.message ||
							"";

						const msg = `Vendor mapping update failed: ${backendMsg}`;
						toast.error(<div>{msg}</div>);
						props.info.inProgress(false);
					});
			}
		} else {
			saveHttp_call()
				.then((response) => {
					props.onClose();
					toast.success(<div>Vendor mapping updated successfully</div>);
					props.info.inProgress(false);
				})
				.catch((xhr) => {
					if (xhr?._validationError) {
						props.info.inProgress(false);
						return;
					}

					const backendMsg =
						xhr?.response?.data?.errorMessage ||
						xhr?.response?.data?.message ||
						xhr?.message ||
						"";

					const msg = `Vendor mapping update failed: ${backendMsg}`;
					toast.error(<div>{msg}</div>);
					props.info.inProgress(false);
				});
		}
	}, [mappedFields, taxCode, editorType, vendor, markAsCompleted, dateFormats, invoiceUserStatusId, validateFields, validateCallLetterBeforeSave]);

	const callLetterBlurSubmitButtonProps = {
		'data-skip-call-letters-blur': 'true',
		onMouseDown: () => {
			skipCallLetterBlurRef.current = true;
		},
		onMouseUp: () => {
			skipCallLetterBlurRef.current = false;
		},
		onMouseLeave: () => {
			skipCallLetterBlurRef.current = false;
		}
	};

	const validateInvoiceContainsText = React.useCallback((inputText) => {
		if (!fieldData) return false;

		const cleanedInput = String(inputText || "")
			.replace(/\s+/g, "") 
			.replace(/\r?\n|\t/g, "") 
			.trim()
			.toLowerCase();

		if (!cleanedInput) return false;

		const invoiceString = JSON.stringify(fieldData)
			.replace(/\s+/g, "")
			.replace(/\r?\n|\t/g, "")
			.trim()
			.toLowerCase();

		return invoiceString.includes(cleanedInput);
	}, [fieldData]);

	const validateAdditionalVendorIdentifier = React.useCallback(() => {
		let mappedObject = getUserMappedValues();

		if (mappedObject.additionalVendorIdentifier === "InvoiceContains") {

			const typedValue = mappedObject.additionalVendorIdentifierValue;

			if (!typedValue || String(typedValue).trim() === "") {
				toast.error(<div>Please enter a value for Additional Vendor Identifier.</div>);
				props.info.inProgress(false);
				return false;
			}

			if (!validateInvoiceContainsText(typedValue)) {
				toast.error(<div>Entered Additional Vendor Identifier text does not exist on the invoice.</div>);
				props.info.inProgress(false);
				return false;
			}
		}

		return true;
	}, [mappedFields, fieldData]);


	const handleMultiCompanyConfirm = (companyList) => {
		setOpenMultiCompanyDialog(false);

		saveHttp_call(null, companyList.vendorCompanyLists)
			.then((response) => {
				const {
					successfulCompanies = [],
					failedCompanies = [],
					transferredResults = []
				} = response.data;

				if (successfulCompanies.length === 0 && failedCompanies.length === 0) {
					toast.success('Vendor mapping updated successfully.');
					props.info.inProgress(false);
					
					props.onClose(
						{
							reopenInvoice: processInvoice === true,
							invoiceDocumentId: props.info?.invoiceDocument?.invoiceDocumentId
						},
						true
					);

					return;
				}

				setResultMessages({
					success: successfulCompanies,
					failure: failedCompanies,
					transferredResults
				});

				setResultDialogOpen(true);
				props.info.inProgress(false);
			})
			.catch((xhr) => {
				let successfulCompanies = [];
				let failedCompanies = [];

				try {
					if (xhr.response && xhr.response.data) {
						successfulCompanies = xhr.response.data.successfulCompanies || [];
						failedCompanies = xhr.response.data.failedCompanies || [];
					}
				} catch (err) {
					
				}

				if (successfulCompanies.length > 0 || failedCompanies.length > 0) {
					setResultMessages({
						success: successfulCompanies,
						failure: failedCompanies,
					});
					setResultDialogOpen(true);
				} else {
					toast.error('Vendor mapping update failed.');
				}

				props.info.inProgress(false);
			});
	};


	const fetchCompanyList = React.useCallback(() => {
		const userInfo = JSON.parse(localStorage.userInfo || '{}');
		const resourceId = userInfo.id;
		const uri = `/api/invoicedocument/companyList?resourceId=${encodeURIComponent(resourceId)}`;

		httpGet(uri)
			.then((response) => {
				const companyData = response.data;

				const company = (companyData || []).filter(c => c.companyCode == props.info?.invoiceDocument?.companyCode);
				setcompanyName(company[0].coName);
				const companies = (companyData || []).filter(c => c.companyCode !== props.info?.invoiceDocument?.companyCode);
				setSelectedCompanyList(companies);
			})
			.catch((error) => {
				toast.error('Error fetching company list');
			});
	}, [props.info?.invoiceDocument?.companyCode]);


	const saveHttp_call = React.useCallback((preview = null, vendorCompanyLists = null) => {
		let mappedObject = getUserMappedValues();

		if (mappedObject.additionalVendorIdentifier === "InvoiceContains") {

			const userText = mappedObject.additionalVendorIdentifierValue;

			if (!userText || String(userText).trim() === "") {
				toast.error(<div>Please enter a value for Additional Vendor Identifier.</div>);
				props.info.inProgress(false);
				return Promise.reject({ _validationError: true });
			}

			if (!validateInvoiceContainsText(userText)) {
				toast.error(<div>Entered Additional Vendor Identifier text does not exist on the invoice.</div>);
				props.info.inProgress(false);
				return Promise.reject({ _validationError: true });
			}
		}

		if (preview) {
			mappedObject.saveForPreview = preview;
			mappedObject.markAsCompleted = false;
			mappedObject.invoiceDocumentEditor = {};
			mappedObject.invoiceDocumentEditor.invoiceDocumentFileLocation = props.info?.invoiceDocument?.invoiceDocumentFileLocation;
		}

		if (vendorCompanyLists) {
			mappedObject.vendorCompanyLists = vendorCompanyLists;
			mappedObject.companyName = companyName;
		}

		mappedObject.invoiceDateFieldFormat = convertToMySQLFormatCustom(dateFormats.invoiceDateFieldFormat);
		mappedObject.dueDateFieldFormat = convertToMySQLFormatCustom(dateFormats.dueDateFieldFormat);
		mappedObject.serviceStartDateFieldFormat = convertToMySQLFormatCustom(dateFormats.serviceTermStartDateFieldFormat);
		mappedObject.serviceEndDateFieldFormat = convertToMySQLFormatCustom(dateFormats.serviceTermEndDateFieldFormat);
		mappedObject.serviceStartDate = String(mappedObject.serviceStartDate ?? '').replace(/\r?\n/g, ' ').trim();
		mappedObject.serviceEndDate = String(mappedObject.serviceEndDate ?? '').replace(/\r?\n/g, ' ').trim();
		mappedObject.invoiceUserStatusId = invoiceUserStatusIdRef.current ? parseInt(invoiceUserStatusIdRef.current, 10) : null;

		props.info.inProgress(true);

		let promise = httpPost('api/InvoiceDocument/documentvendormapping', mappedObject);
		return promise;
	}, [mappedFields, taxCode, editorType, vendor, markAsCompleted, dateFormats, invoiceUserStatusId]);


		const setEditorTypeValue = React.useCallback((type) => {
			if (type !== editorType) {
				setIsDirty(true);
				if (props.modelDefId === 1) {
					setMappedFields({ ...mappedFields, ioNumber: { ...mappedFields.ioNumber, value: '', mappedField: '' } })
				}
			}
			setEditorType(type);


		}, [mappedFields, editorType]);

		const closeVendorDialog = React.useCallback((type, selectedInvoiceUserStatusId = '') => {
			const nextInvoiceUserStatusId = selectedInvoiceUserStatusId || '';
			setEditorTypeValue(type);
			invoiceUserStatusIdRef.current = nextInvoiceUserStatusId;
			setInvoiceUserStatusId(nextInvoiceUserStatusId);
			setVendorDialogOpen(false);
		}, [setEditorTypeValue]);

	const handleServiceTermBillingPeriod = (
		mappedFieldkey,
		mappedKey,
		mappedObject,
		mappedField,
		setMappedFields,
		setIsDirty,
		parseBillingPeriod
	) => {
		const isBillingPeriod = isPeriodKey(mappedKey);
		const otherKey = mappedFieldkey === 'serviceTermStartDate' ? 'serviceTermEndDate' : 'serviceTermStartDate';
		const otherWasBillingPeriod = isPeriodKey(mappedFields[otherKey]?.mappedField);

		setMappedFields((prev) => {
			const updated = { ...prev };

			if (isBillingPeriod) {
				updated['serviceTermStartDate'] = {
					...prev['serviceTermStartDate'],
					value: parseBillingPeriod(mappedObject?.Value, 'serviceTermStartDate'),
					rawValue: mappedObject?.Value,
					mappedField: mappedKey,
					type: 'date',
					title: prev['serviceTermStartDate'].title
				};

				updated['serviceTermEndDate'] = {
					...prev['serviceTermEndDate'],
					value: parseBillingPeriod(mappedObject?.Value, 'serviceTermEndDate'),
					rawValue: mappedObject?.Value,
					mappedField: mappedKey,
					type: 'date',
					title: prev['serviceTermEndDate'].title
				};
			}

			else {
				updated[mappedFieldkey] = {
					...prev[mappedFieldkey],
					value: mappedObject ? mappedObject?.Value : '',
					mappedField: mappedKey,
					type: mappedObject ? mappedObject?.Valuetype : '',
					title: prev[mappedFieldkey].title
				};

				if (otherWasBillingPeriod) {
					updated[otherKey] = {
						...prev[otherKey],
						value: '',
						mappedField: '',
						type: '',
						title: prev[otherKey].title
					};
				}
			}

			return updated;
		});

		if (isBillingPeriod) {
			const detected = detectBillingPeriodFormat(mappedObject?.Value);
			setDateFormats(prev => ({
				...prev,
				serviceTermStartDateFieldFormat: detected,
				serviceTermEndDateFieldFormat: detected
			}));
		} else {
			const detected = formatDateByIntelligence(mappedObject ? mappedObject?.Value : '');
			setDateFormats(prev => ({
				...prev,
				[`${mappedFieldkey}FieldFormat`]: detected,
				...(otherWasBillingPeriod ? { [`${otherKey}FieldFormat`]: '' } : {})
			}));
		}

		setIsDirty(true);
	};

	const handleAdditionalVendorIdentifier = (mappedKey, info) => {
		const isInvoiceContains = mappedFields.additionalVendorIdentifier?.mappedField === 'InvoiceContains';
		const typed = !info.event.target.tagName;
		const getMappedObj = () =>
			getObjectfromFieldDataRecord(mappedKey) ||
			getObjectfromFieldDataLines(mappedKey) ||
			getObjectfromFieldDataKeyValues(mappedKey);

		if (isInvoiceContains && typed) {
			return {
				mappedField: 'InvoiceContains',
				value: mappedKey,
				type: 'string'
			};
		}

		if (mappedKey === 'InvoiceContains') {
			return {
				mappedField: 'InvoiceContains',
				value: '',
				type: 'string'
			};
		}

		const obj = getMappedObj();
		return {
			mappedField: mappedKey,
			value: obj?.Value || '',
			type: obj?.Valuetype || 'string'
		};
	};


		const field_changehandler = React.useCallback((info) => {
			//let mappedKeyValueParent = info.event.target.value;
			let mappedKeyValue = info.event.target.value;
			let mappedFieldkey = info.value;
			//const [key, parent] = mappedKeyValueParent.split('|');
			let mappedKey = mappedKeyValue || '';
			let mappedObject = null;
			let isDetailObject = true;
			let mappedParent = '';

			if (mappedFieldkey === 'additionalVendorIdentifier') {
				const updated = handleAdditionalVendorIdentifier(mappedKey, info);

				setMappedFields(prev => ({
					...prev,
					additionalVendorIdentifier: {
						...prev.additionalVendorIdentifier,
						...updated
					}
				}));

				setIsDirty(true);
				return;
			}

			if (['mediaType', 'callLetter', 'band'].includes(mappedFieldkey)) {
				setMappedFields((prev) => ({
					...prev,
					[mappedFieldkey]: {
						...prev[mappedFieldkey],
						value: info.event.target.value,
						mappedField: '',
						type: 'string',
						title: ''
					}
				}));
				setIsDirty(true);
				return;
			}

			//if ((parent || '') !== '') {
			//	switch (parent) {
			//		case 'Records':
			//			mappedObject = getObjectfromFieldDataRecord(mappedKey);
			//			mappedParent = 'Records';
			//			break;
			//		case 'Lineitems':
			//			mappedObject = getObjectfromFieldDataLines(mappedKey);
			//			mappedParent = 'Lineitems';
			//			break;
			//		case 'KeyValues':
			//			mappedObject = getObjectfromFieldDataKeyValues(mappedKey);
			//			mappedParent = 'KeyValues'
			//			break;

			//	}
			//} else
			//{
			if (mappedKeyValue) {
				if (mappedFieldkey === 'ioNumber' && editorType === 'summary') {
					isDetailObject = false;
				}
				if (mappedFields[mappedFieldkey].section === 'details' && isDetailObject) {
					mappedObject = getObjectFromFieldData(mappedKey)
					// table filed
					//if (!mappedObject) {
					//	mappedObject = getObjectfromTable(mappedKey);
					//}
				}
				if (!mappedObject) {
					mappedObject = getObjectfromFieldDataRecord(mappedKey);
					if (!mappedObject) {
						mappedObject = getObjectfromFieldDataLines(mappedKey);
					}
					if (!mappedObject) {
						mappedObject = getObjectfromFieldDataKeyValues(mappedKey);
					}
					// table filed
					//if (!mappedObject) {
					//	mappedObject = getObjectfromTable(mappedKey);
					//}
				}
			}

			//}

			let mappedField = mappedFields[mappedFieldkey];

			if (mappedFieldkey === 'dueDate') {
				mappedField.title = '';
			}

			let updatedDateFormats = { ...dateFormats };
			const detectedFormat = formatDateByIntelligence(mappedObject ? mappedObject?.Value : '');

			// Apply detected format ONLY to the selected field
			updatedDateFormats = {
				...updatedDateFormats,
				[`${mappedFieldkey}FieldFormat`]: detectedFormat
			};


			if (mappedFieldkey === 'serviceTermStartDate' || mappedFieldkey === 'serviceTermEndDate') {
				handleServiceTermBillingPeriod(
					mappedFieldkey,
					mappedKey,
					mappedObject,
					mappedField,
					setMappedFields,
					setIsDirty,
					parseBillingPeriod
				);
				return;
			}

			setMappedFields((prev) => ({
				...prev,
				[mappedFieldkey]: {
					...mappedField,
					value: mappedObject ? mappedObject?.Value : '',
					mappedField: mappedKey,
					type: mappedObject ? mappedObject?.Valuetype : '',
					title: mappedField.title
					//parentSection: mappedParent || ''
				}
			}));
			setDateFormats(updatedDateFormats);
			setIsDirty(true);
		}, [editorType, mappedFields])
		const hasTax_changeHandler = React.useCallback((event) => {
			let ischecked = event.target.checked;
			setIsDirty(true);
			setHasTax(ischecked);
			if (!ischecked) {
				setTaxCode('');
				setMappedFields((prevFields) => ({
					...prevFields,
					taxCode: {
						...prevFields.taxCode,
						value: '',
					},
				}));
			}
		}, [])
	const fieldFormatMapping = {
		invoiceDate: 'invoiceDateFieldFormat',
		dueDate: 'dueDateFieldFormat',
		serviceTermStartDate: 'serviceTermStartDateFieldFormat',
		serviceTermEndDate: 'serviceTermEndDateFieldFormat'
	};
	const fieldFormat_changeHandler = (fieldName, newFormat) => {
		const stateProperty = fieldFormatMapping[fieldName];

		if (stateProperty) {
			setDateFormats((prevFormats) => ({
				...prevFormats,
				[stateProperty]: newFormat
			}));
		}
		setIsDirty(true);
	};
	const bandValidation_changeHandler = React.useCallback((validationResult) => {
		const nextValidation = {
			isValid: validationResult?.isValid !== false,
			message: validationResult?.message || ''
		};
		bandValidationRef.current = nextValidation;
		setBandValidation(nextValidation);
	}, []);

		const hasInvoiceTax_changeHandler = React.useCallback((event) => {
			let ischecked = event.target.checked;
			setIsDirty(true);
			setHasInvoiceTax(ischecked);
			if (!ischecked) {
				setTaxCode('');
				setMappedFields((prevFields) => ({
					...prevFields,
					invoiceTax: {
						...prevFields.invoiceTax,
						value: '',
					},
				}));
			}
		}, [])
		const vendorDialog_closeHandler = React.useCallback((event, _vendor) => {
			if (_vendor) {
				setVendor(_vendor);

				const vendorDisplay = _vendor.siteId
					? `${_vendor.vendorCode} ${_vendor.shortName || ''} / ${_vendor.siteId}`
					: `${_vendor.vendorCode} ${_vendor.shortName || ''}`;

				const finalVendorDisplay = _vendor.shortName ? vendorDisplay : _vendor.vendorCode;

				setMappedFields((prev) => ({
					...prev,
					vendor: { ...prev.vendor, value: finalVendorDisplay },
					invoiceCurrency: { ...prev.invoiceCurrency, value: _vendor.currencyCode }
				}));

				setInvoiceCurrency(_vendor.currencyCode);
			}

			setIsDirty(true);
			setIsVendorDialogOpen(false);
		}, [mappedFields]);
		const tax_changeHandler = React.useCallback((obj) => {
			setIsDirty(true);
			setTaxCode(obj.event);
		}, [])
		const invoiceUserStatus_changeHandler = React.useCallback((event) => {
			const nextInvoiceUserStatusId = event.target.value || '';
			setIsDirty(true);
			invoiceUserStatusIdRef.current = nextInvoiceUserStatusId;
			setInvoiceUserStatusId(nextInvoiceUserStatusId);
		}, [])
		const search_clickHandler = React.useCallback((event) => {
			setIsVendorDialogOpen(true);
		}, [])
		const markAsCompletedChk_ChangeHandler = React.useCallback((event) => {
			var checked = event.target.checked
			setMarkAsCompleted(checked);
			setIsDirty(true);
			if (checked && processInvoice === false) {
				setProcessInvoice(false);
			}
		}, [markAsCompleted, processInvoice])
		//const processInvoiceChk_ChangeHandler = React.useCallback((event) => {
		//	setProcessInvoice(event.target.checked);
		//	setIsDirty(true);
		//}, [processInvoice])
	const handleEditorDilog_close = React.useCallback(({ event }) => {
		setIsDirty(false);
		setInvoiceDocumentEditorDialogOpen(false);
	}, [invoiceDocumentEditorDialogOpen]);
	const preview_clickhandler = React.useCallback((event) => {
		if (!validateAdditionalVendorIdentifier()) {
			return;
		}
			if (!isDirty) {
				setInvoiceDocumentEditorDialogOpen(true);
			} else {
				saveHttp_call('Y')?.then((response) => {
					//toast.success(<div>Vendor mapping updated successfully</div>);
					props.info.inProgress(false);
					setInvoiceDocumentEditorDialogOpen(true);
					setPreviewInvoiceDocument(response.data.invoiceDocumentEditor);
				})
					.catch((xhr) => {
						const backendMsg =
							xhr?.response?.data?.errorMessage ||
							xhr?.response?.data?.message ||
							xhr?.message ||
							"Preview failed";

						toast.error(<div>{`Error: ${backendMsg}`}</div>);
						props.info.inProgress(false);
						setInvoiceDocumentEditorDialogOpen(false);
					})
			}

	}, [mappedFields, taxCode, editorType, vendor, markAsCompleted, isDirty, readOnly, validateAdditionalVendorIdentifier]);
		const advanceEdit_changeHandler = React.useCallback((event) => {
			setAdvanceEdit(event.target.checked);
		}, [advanceEdit])

		const markAsFinalPrompt_closeHandler = React.useCallback((event) => {
			setMarkAsFinalPrompt({
				isOpen: false,
				title: '',
				message: ''
			});
			save_clickHandler();
		}, [mappedFields, taxCode, editorType, vendor, markAsCompleted])
		const markAsFinalPrompt_openHandler = React.useCallback((event) => {
			if (markAsCompleted) {
				let validation = validateFields();
				if (validation.length > 0) {
					toast.error(<div>{validation.map(e => <div>{e}</div>)}</div>, { allowHtml: true });
					return;
				}
			}
			let message = (markAsCompleted) ? 'This action will mark the vendor mapping as final and apply it to all pending invoices for this vendor' :
				'This action will save the vendor mapping only. The mapping will be applied to invoices only when the \'Mark as Final\' flag is turned on.'
			setMarkAsFinalPrompt({
				isOpen: true,
				title: 'Update Vendor Mapping',
				message: message
			});
		}, [markAsCompleted, mappedFields])
		const invoiceTax_changeHandler = React.useCallback((event) => {
			setIsDirty(true);
			setMappedFields({ ...mappedFields, invoiceTax: { ...mappedFields.invoiceTax, value: event } });
		}, [mappedFields])
		// #endregion
		//#region private methods
		const mapToVendorFields = React.useCallback((data) => {
			let _fieldData = JSON.parse(data.fieldData);
			let requestObject = data.documentVendorMapping;
			let vendorIdentifier = data.vendorIdentifier;
			let _isDirty = false;
			let vendorFields = {};
			let mapFields = {};
			let detailFields = {};
			let items = (_fieldData['Lineitems'] || [])
			let mIndex = getMaxWeightedLine((_fieldData['Lineitems'] || []))
			let tableRow = _fieldData['Table']?.Rows[0] || null;
			let nTableRow = [];
			if (tableRow) {
				for (let key in tableRow?.Columns) {
					nTableRow.push({
						Key: key,
						Value: tableRow?.Columns[key],
						ValueType: 'string'
					});
				}
			}
			let listItems = [...((_fieldData['Lineitems'] && _fieldData['Lineitems']?.length > 0 && _fieldData?.Lineitems[mIndex]?.line) || []).map(e => { e.set = 'Lineitems'; return e })];
			let records = [...(_fieldData['Records']).map(e => { e.set = 'Records'; return e })];
			let keyValuesItems = [...(_fieldData?.KeyValues || []).map(e => { e.set = 'KeyValues'; return e })];
			let listOfItems = [...listItems, ...records, ...keyValuesItems];
			for (let field in mappedFields) {
				if (mappedFields[field].defaultMapping) {
					let mfs = mappedFields[field].section?.split('|');
					if (mfs.indexOf('vendor') !== -1) {
						vendorFields[mappedFields[field].defaultMapping] = field
					}
					if (mfs.indexOf('mapped') !== -1) {
							mapFields[mappedFields[field].defaultMapping] = field
					
					}
					if (mfs.indexOf('details') !== -1) {
						//if ((props.info.modelDefId === 1 && !detailFields[mappedFields[field].defaultMapping])
						//	|| props.info.modelDefId === 2
						//) {
						detailFields[mappedFields[field].defaultMapping] = field
						//}

					}
				}
			}
			let _mappedFields = structuredClone(mappedFields);
			_mappedFields = {
				..._mappedFields, vendorIdentifier: { ..._mappedFields.vendorIdentifier, value: vendorIdentifier },
				/*currencyCode: { ..._mappedFields.currencyCode, value: _fieldData['Records'].filter((e) => e.Key === 'CurrencyCode')[0]?.Value }, */
			}
			for (let item of _fieldData['Records']) {
				if (vendorFields[item.Key] || vendorFields[item.Key + '_1']) {
					let mappedObject = _mappedFields[vendorFields[item.Key] || vendorFields[item.Key + '_1']];
					_mappedFields = {
						..._mappedFields, [vendorFields[item.Key] || vendorFields[item.Key + '_1']]: {
							...mappedObject,
							value: item.Value,
							type: item.Valuetype
							//parentSection: requestObject[mappedObject.requestField] === null ? 'Records' : ''
						}
					}
				}
			}
			for (let item of _fieldData['Records']) {
				if (mapFields[item.Key] || mapFields[item.Key + '_1']) {
					let mappedObject = _mappedFields[mapFields[item.Key] || mapFields[item.Key + '_1']];
					_isDirty = (_isDirty || requestObject[mappedObject.requestField] === null);
					_mappedFields = {
						..._mappedFields, [mapFields[item.Key] || mapFields[item.Key + '_1']]: {
							...mappedObject,
							type: item.Valuetype,
							mappedField: requestObject[mappedObject.requestField] === null ? item.Key : '',
							value: requestObject[mappedObject.requestField] === null ? item.Value : '',
							//parentSection: requestObject[mappedObject.requestField] === null ? 'Records' : ''
						}
					}
				}
			}
		
			for (let _key in _mappedFields) {
				if (_mappedFields[_key].defaultMapping === '$function') {
					if (!_mappedFields[_key].value && !_mappedFields[_key].key) {
						if (mappingMethods[_key]) {
							let defaultmapping = mappingMethods[_key](listOfItems);
							if (defaultmapping) {
								if (defaultmapping) {
									_mappedFields = {
										..._mappedFields,
										[_key]: {
											..._mappedFields[_key],
											mappedField: requestObject[_mappedFields[_key].requestField] === null ? defaultmapping.Key : '',
											type: requestObject[_mappedFields[_key].requestField] === null ? defaultmapping.Valuetype : '',
											value: requestObject[_mappedFields[_key].requestField] === null ? defaultmapping.Value : ''
										}
									}
								}
							}
						}

					}
				}
			}

			for (let key of ['broadcastClient', 'broadcastProduct', 'contractNumber']) {
				let mappedObject = _mappedFields[key];
				if (!mappedObject || !mappingMethods[key] || mappedObject.mappedField) {
					continue;
				}

				if (!stringIsNullOrEmpty(requestObject?.[mappedObject.requestField])) {
					continue;
				}

				let defaultmapping = mappingMethods[key](listOfItems);
				if (!defaultmapping) {
					continue;
				}

				_mappedFields = {
					..._mappedFields,
					[key]: {
						...mappedObject,
						mappedField: defaultmapping.Key,
						value: defaultmapping.Value,
						type: defaultmapping.Valuetype
					}
				}
			}

			if (items.length > 0) {
				for (let item of ((items && items[mIndex]?.line) || [])) {
					if (detailFields[item.Key] || detailFields[item.Key + '_1']) {
						let mappedObject = _mappedFields[detailFields[item.Key] || detailFields[item.Key + '_1']];
						_isDirty = (_isDirty || requestObject[mappedObject.requestField] === null);
						_mappedFields = {
							..._mappedFields, [detailFields[item.Key] || detailFields[item.Key + '_1']]: {
								...mappedObject,
								mappedField: requestObject[mappedObject.requestField] === null ? item.Key : '',
								value: requestObject[mappedObject.requestField] === null ? item.Value : '',
								type: item.Valuetype
								//parentSection: requestObject[mappedObject.requestField] === null ? 'Lineitems' : ''
							}
					}
				}
			}
			}
			for (let f of ['serviceTermStartDate', 'serviceTermEndDate']) {
				const mappedObject = _mappedFields[f];
				const billingOption = _fieldData?.BillingPeriodOption?.[0];

				if (billingOption && !mappedObject?.mappedField) {
					_mappedFields[f] = {
						...mappedObject,
						mappedField: billingOption.Key,
						value: parseBillingPeriod(billingOption.Value, f),
						type: 'date'
					};
				}
			}
			if (_fieldData?.BillingPeriodOption?.[0]) {
				const detected = detectBillingPeriodFormat(_fieldData.BillingPeriodOption[0].Value);
				setDateFormats(prev => ({
					...prev,
					serviceTermStartDateFieldFormat: prev.serviceTermStartDateFieldFormat || detected,
					serviceTermEndDateFieldFormat: prev.serviceTermEndDateFieldFormat || detected
				}));
			}

		//table change
		//if (nTableRow.length > 0) {
		//	for (let item of nTableRow) {
		//		if (detailFields[item.Key] || detailFields[item.Key + '_1']) {
		//			let mappedObject = _mappedFields[detailFields[item.Key] || detailFields[item.Key + '_1']];
		//			_isDirty = (_isDirty || requestObject[mappedObject.requestField] === null);
		//			_mappedFields = {
		//				..._mappedFields, [detailFields[item.Key] || detailFields[item.Key + '_1']]: {
		//					...mappedObject,
		//					mappedField: requestObject[mappedObject.requestField] === null ? item.Key : '',
		//					value: requestObject[mappedObject.requestField] === null ? item.Value : '',
		//					type: item.Valuetype
		//					//parentSection: requestObject[mappedObject.requestField] === null ? 'Lineitems' : ''
		//				}
		//			}
		//		}
		//	}
			//}

			manualFields.forEach((key) => {
				_mappedFields[key] = {
					...(_mappedFields[key] || {}),
					value: requestObject[key] || '',
					mappedField: '',
					type: 'string'
				};
			});

			if (stringIsNullOrEmpty(requestObject?.mediaType) && stringIsNullOrEmpty(_mappedFields?.mediaType?.value) && mappingMethods.mediaType) {
				let defaultmapping = mappingMethods.mediaType(listOfItems);
				if (defaultmapping) {
					_mappedFields.mediaType = {
						...(_mappedFields.mediaType || {}),
						value: defaultmapping.Value || '',
						type: defaultmapping.Valuetype || 'string',
						mappedField: ''
					};
				}
			}

		setMappedFields((prev) => ({ ...prev, ..._mappedFields }));
		setMaxWeightedLine(mIndex);
		setIsFirstMap(true);
		//setIsDirty(_isDirty);

	}, [mappedFields, maxWeightedLine]);

	const getObjectfromFieldDataRecord = React.useCallback((key, fieldObject) => {
		let object = null;
		let records = (fieldObject && fieldObject['Records']) || fieldData['Records'];
		for (let i = 0; i < records.length; i++) {
			if (records[i].Key === key) {
				object = records[i];
				break;
			}
		}
		return object;
	}, [fieldData]);
	// table change
	const getObjectfromTable = React.useCallback((key, fieldObject) => {
		let object = null;
		let records = (fieldObject && fieldObject['Table']) || fieldData['Table'];
		let fRecord = records?.Rows[0] || null;
		let nRecord = [];
		if (fRecord) {
			for (let key in fRecord?.Columns) {
				nRecord.push({
					Key: key,
					Value: fRecord?.Columns[key],
					ValueType:'string'
				})
			}
		}
		for (let i = 0; i < nRecord.length; i++) {
			if (nRecord[i].Key === key) {
				object = nRecord[i];
				break;
			}
		}
		return object;
	}, [fieldData])
	const getObjectfromFieldDataKeyValues = React.useCallback((key, fieldObject) => {
		let object = null;
		let records = (fieldObject && fieldObject['KeyValues']) || fieldData['KeyValues'];
		for (let i = 0; i < records.length; i++) {
			if (records[i].Key === key) {
				object = records[i];
				break;
			}
		}
		return object;
	}, [fieldData])
	const getObjectfromFieldDataLines = React.useCallback((key, fieldObject) => {
		let object = null;
		let line = null;
		let lineItems = (fieldObject && fieldObject['Lineitems']) || fieldData['Lineitems'];
		if (lineItems.length > 0) {
			line = lineItems[maxWeightedLine]?.line;
		}
		if (line) {
		 for (let i = 0; i < line.length; i++) {
				if (line[i].Key === key) {
					object = line[i];
					break;
				}
			}
		}

		if (!object) {
			let records = (fieldObject && fieldObject['Records']) || fieldData['Records'];
			for (let i = 0; i < records.length; i++) {
				if (records[i].Key === key) {
					object = records[i];
					break;
				}
			}
		}
		return object;
	}, [fieldData, maxWeightedLine])

	const getObjectFromFieldData = React.useCallback((key, fieldObject) => {
		let mappedObject = null;
		mappedObject = getObjectfromFieldDataLines(key, fieldObject);
		if (mappedObject) {
			mappedObject['parentSection'] = 'Lineitems';
		}
		if (!mappedObject) {
			mappedObject = getObjectfromFieldDataKeyValues(key, fieldObject);
			if (mappedObject) {
				mappedObject['parentSection'] = 'KeyValues';
			}
		}
		if (!mappedObject) {
			mappedObject = getObjectfromFieldDataRecord(key, fieldObject);
			if (mappedObject) {
				mappedObject['parentSection'] = 'Records';
			}
		}
		//table change
		//if (!mappedObject) {
		//	mappedObject = getObjectfromTable(key, fieldObject);
		//	if (mappedObject) {
		//		mappedObject['parentSection'] = 'Table';
		//	}
		//}
		return mappedObject;
	}, [fieldData, maxWeightedLine])

	const getUserMappedValues = React.useCallback(() => {

		let requestObj = {};
		for (let field in mappedFields) {
			if (mappedFields[field] && mappedFields[field].requestField) {
				requestObj[mappedFields[field].requestField] = mappedFields[field].mappedField;
			}
		}
		requestObj['vendorMappingId'] = documentVendorMapping?.vendorMappingId || 0;
		requestObj['companyCode'] = 0;
		requestObj['invoiceDocumentId'] = props.info?.invoiceDocument?.invoiceDocumentId;
		requestObj['modelDefId'] = props?.info?.modelDefId;
		requestObj['vendorCode'] = vendor?.vendorCode || null;
		requestObj['detailflag'] = editorType === 'detail';
		requestObj['taxCode'] = (stringIsNullOrEmpty(mappedFields?.invoiceTax?.value) && taxCode) || null;
		requestObj['sampleFileLocation'] = documentVendorMapping?.sampleFileLocation;
		requestObj['currencyCode'] = mappedFields?.invoiceCurrency?.value || invoiceCurrency;
		requestObj['scannedCurrencyCode'] = mappedFields?.currencyCode?.value;
		requestObj['vendorIdentifier'] = mappedFields?.vendorIdentifier?.value;
		requestObj['markAsCompleted'] = markAsCompleted;
		requestObj['amount'] = mappedFields?.ioInvoiceAmount?.mappedField;
		requestObj['revisionId'] = (props?.info?.invoiceDocument?.revisionId || 0);
		const broadcastTaxValues = (mappedFields?.invoiceTax?.value || '').split(ConstantsSymbols.TAXKEYS_DELIM);
		requestObj['invoiceTax'] = props?.info?.modelDefId === 3
			? broadcastTaxValues[0] || ''
			: mappedFields?.invoiceTax?.value;
		requestObj['invoiceLocalTax'] = props?.info?.modelDefId === 3 ? broadcastTaxValues[1] || '' : '';
		requestObj['mediaType'] = mappedFields?.mediaType?.value || '';
		requestObj['callLetter'] = mappedFields?.callLetter?.value || '';
		requestObj['callLetterKeyValue'] = mappedFields?.callLetterKeyValue?.mappedField || '';
		requestObj['band'] = mappedFields?.band?.value || '';
		requestObj['bandKeyValue'] = mappedFields?.bandKeyValue?.mappedField || '';
		requestObj['paymentTermCode'] = mappedFields?.paymentTermCode?.value || '';
		requestObj['additionalVendorIdentifier'] = mappedFields?.additionalVendorIdentifier?.mappedField || "";
		requestObj['additionalVendorIdentifierValue'] = mappedFields?.additionalVendorIdentifier?.value || "";
 
		return requestObj;
	}, [mappedFields, taxCode, editorType, vendor, markAsCompleted, invoiceUserStatusId])
	const getMappedKeysFromRequest = React.useCallback((data) => {
		let _fieldData = (data.fieldData);
		let requestObject = data.documentVendorMapping;
		let vendorIdentifier = data.vendorIdentifier;
		let _mappedFields = structuredClone(mappedFields);
		let _vendor = data.vendor;
		_mappedFields = {
			..._mappedFields, vendorIdentifier: { ..._mappedFields.vendorIdentifier, value: vendorIdentifier }
			//currencyCode: { ..._mappedFields.currencyCode, value: _fieldData['Records'].filter((e) => e.Key === 'CurrencyCode')[0]?.Value }
		}
		if (data.vendor) {
			_mappedFields = {
				..._mappedFields,
				vendor: { ..._mappedFields.vendor, value: (_vendor.vendorCode + " " + _vendor.shortName + " / " + _vendor.siteId) }
			}
		}

		if (requestObject) {
			for (let key in _mappedFields) {
				let requestKey = _mappedFields[key]?.requestField;
				let fData = getObjectFromFieldData(requestObject[requestKey], _fieldData);
				if (requestKey && requestObject[requestKey]) {
					if (requestKey === 'invoiceTax') {
						_mappedFields[key].mappedField = requestObject[requestKey];
						_mappedFields[key].value = requestObject?.invoiceTax;
					}
					else if (key === 'serviceTermStartDate' || key === 'serviceTermEndDate') {
						const mappedKey = (requestObject[requestKey] || '').toLowerCase();
						if (isPeriodKey(mappedKey)) {
							_mappedFields[key].mappedField = requestObject[requestKey];
							_mappedFields[key].value = parseBillingPeriod(fData?.Value, key);
							_mappedFields[key].type = 'keyvaluepair';
							_mappedFields[key].rawValue = fData?.Value || ''; 
							const src = requestObject?.serviceStartDateFieldFormat || requestObject?.serviceEndDateFieldFormat || fData?.Value;
							const detected = normalizeUiFormat(detectBillingPeriodFormat(src));
							setDateFormats(prev => ({
								...prev,
								serviceTermStartDateFieldFormat: prev.serviceTermStartDateFieldFormat || detected,
								serviceTermEndDateFieldFormat: prev.serviceTermEndDateFieldFormat || detected
							}));
						} else {
							_mappedFields[key].mappedField = requestObject[requestKey];
							_mappedFields[key].value = fData?.Value;
							_mappedFields[key].type = fData?.Valuetype || '';
						}
					}
					else {
						_mappedFields[key].mappedField = requestObject[requestKey];
						_mappedFields[key].value = fData?.Value;
						_mappedFields[key].type = fData?.Valuetype || '';
					}
				}
			}
			if (requestObject.additionalVendorIdentifier) {
				_mappedFields.additionalVendorIdentifier = {
					..._mappedFields.additionalVendorIdentifier,
					mappedField: requestObject.additionalVendorIdentifier,
					value: requestObject.additionalVendorIdentifierValue || '',
					type: 'string'
				};
			}
			if (props?.info?.modelDefId === 3) {
				_mappedFields.invoiceTax.value = [requestObject.invoiceTax, requestObject.invoiceLocalTax]
					.filter(Boolean)
					.join(ConstantsSymbols.TAXKEYS_DELIM);
			}
		}


		setMappedFields(_mappedFields);
		setLoadComplete(true);
	}, [mappedFields, vendor, isFirstMap, maxWeightedLine]);

	const normalizeYear = (yearRaw) => {
		let yearNum = parseInt(yearRaw, 10);
		if (yearRaw.length === 2) {
			if (yearNum > 60) return 1900 + yearNum;
			return 2000 + yearNum;
		}
		return yearNum;
	}

	const parseSingleDate = (datePart, fieldKey) => {
		const monthYearMatch = datePart.match(/([A-Za-z]{3,9})[\s\-\/]+(\d{2,4})|(\d{2,4})[\s\-\/]+([A-Za-z]{3,9})/i);

		if (monthYearMatch) {
			let monthName = monthYearMatch[1] || monthYearMatch[4];
			let yearRaw = monthYearMatch[2] || monthYearMatch[3];

			if (monthName && yearRaw) {
				let year = normalizeYear(yearRaw);

				const monthIndex = new Date(`${monthName} 1, 2000`).getMonth();

				if (!isNaN(monthIndex)) {
					const startDate = new Date(year, monthIndex, 1);

					if (!isNaN(startDate.getTime())) {
						const endDate = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);

						return toDate(fieldKey === 'serviceTermEndDate' ? endDate : startDate);
					}
				}
			}
		}

		const fallbackDate = new Date(datePart);
		if (!isNaN(fallbackDate.getTime())) {
			const year = normalizeYear(String(fallbackDate.getFullYear()));
			const startDate = new Date(year, fallbackDate.getMonth(), 1);
			const endDate = new Date(year, fallbackDate.getMonth() + 1, 0);
			return toDate(fieldKey === 'serviceTermEndDate' ? endDate : startDate);
		}

		return datePart;
	}

	const parseBillingPeriod = (val, fieldKey) => {
		if (!val) return '';

		const raw = String(val).trim();

		const numRange = raw
			.replace(/[–—]/g, '-')
			.match(/(\d{1,4}[\/-]\d{1,2}[\/-]\d{2,4})\s*(?:to|through|thru|until|till|-)\s*(\d{1,4}[\/-]\d{1,2}[\/-]\d{2,4})/i);

		if (numRange) {
			const [, left, right] = numRange;

			const parseNum = (s) => {
				const [a, b, c] = s.split(/[\/-]/).map(x => x.trim());
				let Y, M, D;

				if (a.length === 4) {
					Y = a; M = b; D = c;
				} else {                      
					D = a; M = b; Y = c;
				}

				const yyyy = normalizeYear(String(Y));
				const dt = new Date(Number(yyyy), Number(M) - 1, Number(D));
				return isNaN(dt.getTime()) ? null : dt;
			};

			const startDate = parseNum(left);
			const endDate = parseNum(right);

			if (startDate && endDate) {
				return toDate(fieldKey === 'serviceTermEndDate' ? endDate : startDate);
			}
		}

		const dmyRange = raw
			.replace(/[–—]/g, '-')
			.match(/(\d{1,2}[-\/]\s*[A-Za-z]{3,9}[-\/]\s*\d{2,4})\s*(?:to|-)\s*(\d{1,2}[-\/]\s*[A-Za-z]{3,9}[-\/]\s*\d{2,4})/i);

		if (dmyRange) {
			const [, left, right] = dmyRange;

			const parseDMY = (s) => {
				const parts = s.replace(/,/g, '').replace(/\s+/g, '').split(/[-\/]/);
				const [dd, mon, yy] = parts;
				const yyyy = normalizeYear(yy);
				const date = new Date(`${mon} ${Number(dd)}, ${yyyy}`);
				return isNaN(date.getTime()) ? null : date;
			};

			const startDate = parseDMY(left);
			const endDate = parseDMY(right);

			if (startDate && endDate) {
				return toDate(fieldKey === 'serviceTermEndDate' ? endDate : startDate);
			}
		}

		const dateTokens =
			raw
				.match(/([A-Za-z]{3,9})|\d{1,4}|[\/\-]/gi)
				?.join(' ')
				.replace(/\s+/g, ' ')
				.trim() || raw;

		if (!dateTokens) return raw;

		const rangeRegex =
			/([A-Za-z]{3,9})\s+(\d{1,2})(?:[, ]\s*(\d{2,4}))?\s*[-–—]\s*([A-Za-z]{3,9})?\s*(\d{1,2})(?:[, ]\s*(\d{2,4}))?/i;
		const rangeMatch = dateTokens.match(rangeRegex);

		if (rangeMatch) {
			let [, m1, d1, y1, m2, d2, y2] = rangeMatch;

			if (!m2) m2 = m1;
			if (y1 && !y2) y2 = y1;
			if (!y1 && y2) y1 = y2;

			const year1 = normalizeYear(String(y1 || ''));
			const year2 = normalizeYear(String(y2 || y1 || ''));

			const startDate = new Date(`${m1} ${d1}, ${year1}`);
			const endDate = new Date(`${m2} ${d2}, ${year2}`);

			if (!isNaN(startDate.getTime()) && !isNaN(endDate.getTime())) {
				return toDate(fieldKey === 'serviceTermEndDate' ? endDate : startDate);
			}
		}

		return parseSingleDate(dateTokens, fieldKey);
	};


	const transformToIdentity = React.useCallback((_fieldData) => {
		// table change
		let keys = ['Records', 'Lineitems', 'KeyValues'/*,'Table'*/];
		let finalObject = {};
		for (let key of keys) {
			let obj = _fieldData[key];
			if (obj) {
				if (key === 'Lineitems') {
					finalObject[key] = obj.map((e, i) => {
						e.line = e.line?.map((k, j) => {
							return { ...k, parentKey: key }
						})
						return { ...e, parentKey: key }
					})
				}
				// table change
				//else if (key === 'Table') {
				//	finalObject[key] = obj;
				//}
				else {
					finalObject[key] = obj.map((e, i) => ({ ...e, parentKey: key }));
				}
			}
		}
		let dict = {};
		for (let object of finalObject['KeyValues']) {
			if (!dict[object.Key]) {
				dict[object.Key] = object;
			}
		}
		let uniqueList = [];
		for (let key in dict) {
			uniqueList.push(dict[key]);
		}
		finalObject['KeyValues'] = uniqueList;
		const billingPeriod = findBillingPeriodKV(_fieldData?.KeyValues || []);

		if (billingPeriod) {
			finalObject['BillingPeriodOption'] = [{
				Key: billingPeriod.Key,
				Value: billingPeriod.Value,
				Valuetype: 'date',
				parentKey: 'Records'
			}];
		} else {
			finalObject['BillingPeriodOption'] = [];
		}
		return finalObject;
	}, []);

	const getMaxWeightedLine = React.useCallback((lines) => {
		let maxLineIndex = 0;
		let maxLength = 0;
		for (let i = 0; i < lines.length; i++) {
			if (lines[i].line.length > maxLength) {
				maxLength = lines[i].line.length;
				maxLineIndex = i;
			}
		}
		return maxLineIndex;
	}, []);
	const paymentTermsToFlatObject = React.useCallback((_paymentTerms) => {
		let obj = {};
		if (!_paymentTerms) return null;
		for (let item of _paymentTerms) {
			let daysDue = item?.daysDue || 0;
			obj[item?.termsCode?.toLowerCase()] = {
				daysDue: daysDue, code: item?.termsCode?.toLowerCase()
			};
			for (let innerItem of (item?.paymentTermsMaps || [])) {
				obj[innerItem?.apamInvoiceTermsCode?.toLowerCase()] = {
					daysDue: daysDue, code: item?.termsCode?.toLowerCase()
				};
			}
		}
		return obj;
	}, []); 

	const modifyJsonData = React.useCallback((fieldData, modificationFieldMaps) => {
		if (modificationFieldMaps['CurrencyCode']) {
			modifyCurrencyField(fieldData, modificationFieldMaps['CurrencyCode']);
		}
		return JSON.stringify(fieldData);
	}, []); 
	const modifyCurrencyField = React.useCallback((fieldData,newValue) => {
		let currencyCode = getObjectfromFieldDataRecord('CurrencyCode', fieldData);
		if (!currencyCode && newValue) {
			if (Array.isArray(fieldData['Records'])) {
				fieldData['Records'].push({ Key: 'CurrencyCode', Value: newValue, Valuetype:'string'})
			}
		}
	}, []); 


	//#endregion 
	return (
		<>
			<Box sx={{ flexGrow: 1 }}>
				<h1 className="vendorMapDialog-header-title" style={{ marginLeft: 15 }}>{"Vendor Mapping"}</h1>
				<Grid container spacing={1}>
					<Grid item xs={6}>
						<InvoiceDocumentViewer
							info={
								{
									inProgress: props.info.inProgress,
									modelDefId: props.info.modelDefId,
									mode:'Vendor Map',
									invoiceDocumentFileLocation: props.info?.invoiceDocument?.invoiceDocumentFileLocation,
									inline: true
								}
							}
						></InvoiceDocumentViewer>
					</Grid>
					{fieldData && <Grid item xs={6} className='vendorMapEditor'>
						<div className="mainTable box-container">
							<VendorInformation style={style}
								{...props} editorType={editorType}
								vendorIdentifier={vendorIdentifier}
								fieldData={fieldData}
								setEditorType={setEditorTypeValue}
								mappedFields={mappedFields}
								documentVendorMapping={documentVendorMapping}
								search_clickHandler={search_clickHandler}
								advanceEdit={advanceEdit}
								advanceEdit_changeHandler={advanceEdit_changeHandler}
								readOnly={readOnly}
								modelDefId={props.info.modelDefId}
								isChangingNotAllowed={isChangingNotAllowed}
								field_changehandler={field_changehandler}
								regex={regex}
							>
							</VendorInformation>
							<MappedInvoiceFeilds style={style} {...props}
								editorType={editorType}
								fieldData={fieldData}
								mappedFields={mappedFields}
								vendorIdentifier={vendorIdentifier}
								field_changehandler={field_changehandler}
								documentVendorMapping={documentVendorMapping}
								hasTax={hasTax}
								hasTax_changeHandler={hasTax_changeHandler}
								fieldFormat_changeHandler={fieldFormat_changeHandler}
								taxCode={taxCode}
								taxddl={taxes}
								tax_changeHandler={tax_changeHandler}
								modelDefId={props.info.modelDefId}
								maxWeightedLine={maxWeightedLine}
								regex={regex}
								advanceEdit={advanceEdit}
								readOnly={readOnly}
								taxAmount={taxAmount}
								paymentTerms={paymentTerms}
								invoiceCurrency={invoiceCurrency}
								vendor={vendor}
								invoiceTax_changeHandler={invoiceTax_changeHandler}
								invoiceTaxAmount={invoiceTaxAmount}
								hasInvoiceTax_changeHandler={hasInvoiceTax_changeHandler}
								hasInvoiceTax={hasInvoiceTax}
								taxSettings={taxSettings}
								dateFormats={dateFormats}
								invoiceUserStatuses={invoiceUserStatuses}
								invoiceUserStatusId={invoiceUserStatusId}
								invoiceUserStatus_changeHandler={invoiceUserStatus_changeHandler}
								userStatusDisplayName={userStatusDisplayName}
								onBandValidationChange={bandValidation_changeHandler}
								registerCallLetterValidator={registerCallLetterValidator}
								skipCallLetterBlurRef={skipCallLetterBlurRef}
							></MappedInvoiceFeilds>
							<Box>
								<Grid container key={100} spacing={style.mainRowSpacing}>
									<Grid item xs={style.cellOneWidth} sx={style.cellOneStyle}><label>Mark As Completed<br />(Forced Mapped)</label></Grid>
									<Grid key={'a' + 100} item container alignItems={'center'} xs={style.cellTwoWidth} sx={style.cellTwoStyle}>
										<input onChange={markAsCompletedChk_ChangeHandler} disabled={readOnly} type='checkbox' checked={markAsCompleted} />
									</Grid>
								</Grid>
							</Box>
							{/*{markAsCompleted && canProcessInvoice && (<Box>*/}
							{/*	<Grid container key={100} spacing={style.mainRowSpacing}>*/}
							{/*		<Grid item xs={style.cellOneWidth} sx={style.cellOneStyle}><label>Open Invoice after Save & Apply</label></Grid>*/}
							{/*		<Grid key={'a' + 100} item container alignItems={'center'} xs={style.cellTwoWidth} sx={style.cellTwoStyle}>*/}
							{/*			<input onChange={processInvoiceChk_ChangeHandler} disabled={readOnly} type='checkbox' checked={processInvoice} />*/}
							{/*		</Grid>*/}
							{/*	</Grid>*/}
							{/*</Box>*/}
							{/*)}*/}
						</div>
						<Box
							sx={{
								position: 'sticky',
								bottom: 0,
								zIndex: 1200,
								backgroundColor: '#fff',
								borderTop: '1px solid #e0e0e0',
								py: 1
							}}
						>
							<Grid container item justifyContent={'center'}>
								<button {...callLetterBlurSubmitButtonProps} className="btn-blue" onClick={(event) => {
									preview_clickhandler(event);
								}}>Preview</button>
								{/*{!readOnly && props.info.mode !== 'Copy' && <button className="btn-blue" onClick={markAsFinalPrompt_openHandler}>{'Save and Apply to Unmatched Invoices'}</button>}*/}
								{!isChangingNotAllowed && props.info.mode !== 'Copy' && <button {...callLetterBlurSubmitButtonProps} className="btn-blue" onClick={save_clickHandler}>{(markAsCompleted) ? 'Save and Apply to Unmatched Invoices': 'Save'}</button>}
								{!isChangingNotAllowed && props.info.mode === 'Copy' && <button {...callLetterBlurSubmitButtonProps} className="btn-blue" onClick={save_clickHandler}>{'Save'}</button>}
								<button {...callLetterBlurSubmitButtonProps} className="btn-grey" onClick={(event) => { props.onClose(event, false) }}>Close </button>
							</Grid>
						</Box>
						<VendorMapDialog
							isOpen={vendorDialogOpen}
							modelDefId={props.info.modelDefId }
							onClose={closeVendorDialog}
							onCloseSuccess={() => {
								setVendorDialogOpen(false);
								props.onClose();
							}}
							editorType={editorType}
							vendorIdentifier={vendorIdentifier}
							setEditorType={setEditorType}
							vendorMappingId={documentVendorMapping?.vendorMappingId || 0}
							invoiceUserStatusId={invoiceUserStatusId || ''}
							info={props.info}
						></VendorMapDialog>
						<VendorLookup info={{
							openDialog: isVendorDialogOpen,
							inProgress: props.info.inProgress,
							invoiceModel: {
								vendorCode: props.info.invoiceDocument?.vendorCode,
								siteId: props.invoiceDocument?.siteId
							}
						}} onClose={vendorDialog_closeHandler} />
						<MultiCompanyVendorLookup
							open={openMultiCompanyDialog}
							onClose={() => setOpenMultiCompanyDialog(false)}
							currentCompanyCode={props.info?.invoiceDocument?.companyCode}
							vendorCode={vendor?.vendorCode}
							mode="to Create Vendor Mapping"
							inProgress={props.info.inProgress}
							getUserMappedValues={getUserMappedValues }
							onConfirm={handleMultiCompanyConfirm}
						/>

						{/* #region Preview Dialog*/}
						<Dialog
							open={invoiceDocumentEditorDialogOpen}
							fullWidth maxWidth="xl"
						>
							{invoiceDocumentEditorDialogOpen && <InvoiceDocumentEditor
								info={{
									rowData: props.info?.invoiceDocument,
									mode: 'Test',
									inProgress: props.info.inProgress,
									modelDefId: props.info.modelDefId,
									previewInvoiceDocument: previewInvoiceDocument,
								}}
								clientInfo={{
									rowData: props.info?.invoiceDocument,
									mode: 'Test',
									inProgress: props.info.inProgress,
									modelDefId: props.info.modelDefId,
								}}
								onClose={handleEditorDilog_close}
							></InvoiceDocumentEditor>}
						</Dialog>
						{resultDialogOpen && (
							<Dialog
								open={true}
								fullWidth
								maxWidth="sm"
							>
								<DialogTitle>Vendor Mapping Results</DialogTitle>
								<DialogContent dividers>
									{resultMessages.success.length > 0 && (
										<div style={{ marginBottom: '10px' }}>
											{resultMessages.success.map((companyName, index) => {
												const company = selectedCompanyList.find(c => c.coName === companyName);
												const companyCode = company?.companyCode;

												const match = resultMessages.transferredResults?.find(
													r => r.companyCode === companyCode
												);

												const hasPT = !!match?.paymentTermsMessage;
												const hasTC = !!match?.taxCodeMessage;
												const hasUS = !!match?.userStatusMessage;

												let message = '';
												let noteColor = 'green';

												let missingFields = [];

												if (hasPT) {
													missingFields.push('Payment Term');
												}

												if (hasTC) {
													missingFields.push('Tax Code');
												}

												if (hasUS) {
													missingFields.push('User Status');
												}

												if (missingFields.length > 0) {
													message = `Vendor mapping created with warning: ${missingFields.join(', ')} missing in ${companyName}`;
													noteColor = '#d98c00';
												} else {
													message = `Vendor mapping created in ${companyName}`;
												}

												return (
													<div
														key={`success-${index}`}
														style={{
															color: hasPT || hasTC || hasUS ? noteColor : 'green',
															fontSize: '16px',
															marginBottom: '6px'
														}}
													>
														{message}
													</div>
												);
											})}
										</div>
									)}

									{resultMessages.failure.length > 0 && (
										<div style={{ marginBottom: '10px', color: 'red', fontSize: '16px' }}>
											Vendor mapping already exists for {resultMessages.failure.join(", ")}.
										</div>
									)}
								</DialogContent>


								<DialogActions>
									<Button
										onClick={() => {
											setResultDialogOpen(false);
											props.onClose(
												{
													reopenInvoice: processInvoice === true,
													invoiceDocumentId: props.info?.invoiceDocument?.invoiceDocumentId
												},
												true
											);
										}}
									>
										Close
									</Button>
								</DialogActions>
							</Dialog>
						)}


						<VendorMappingDialogPrompt
							{...markAsFinalPrompt}
							onClose={markAsFinalPrompt_closeHandler }
						/>
						{/* #endregion*/}
					</Grid>}
				</Grid>
			</Box>

		</>
	);
}